'use strict';
import fuse from '../../../_libs/redux-fusion/index';
import {NavigationBarHOC} from '../../../components/views/NavigationBar';
import {ManageAccessStreamedComponent} from '../../../core-components/ManageAccess/ManageAccessContainer';
import {TaskNavigationBarView} from './TaskNavigationBarView';


const component = fuse(ManageAccessStreamedComponent)(TaskNavigationBarView);
export const TaskNavigationBarContainer = NavigationBarHOC(component);



// WEBPACK FOOTER //
// ./src/js/tasks/components/TaskNavigationBar/TaskNavigationBarContainer.js